export default [
  //權限管理
  // {
  //   scope: ['1101'],
  //   component: 'CNavTitle',
  //   moduleName: '權限管理',
  //   name: '',
  // },
  {
    scope: ['1101'], // 為權限管理的
    component: 'CNavItem',
    functionName: 'UserMgt', // 為權限管理的
    name: 'Cheerful Give 樂易捐連結',
    to: '/cheerfulGive',
  },
  //Leaderboard Dashboard
  // {
  //   scope: ['7101', '7102'],
  //   component: 'CNavTitle',
  //   moduleName: 'Leaderboard Dashboard',
  //   name: 'Leaderboard Dashboard',
  // },
  // {
  //   scope: ['7101'],
  //   component: 'CNavItem',
  //   functionName: 'Leaderboard Dashboard',
  //   name: '7101 - 排行榜一覽',
  //   to: '/leaderboard/7101',
  // },
  // {
  //   scope: ['7102'],
  //   component: 'CNavItem',
  //   functionName: 'Leaderboard Dashboard',
  //   name: '7102 - 排行榜查詢',
  //   to: '/leaderboard/7102',
  // },

  //心禮卡管理
  {
    scope: ['3101','3102', '3103'],
    component: 'CNavTitle',
    moduleName: '會員管理',
    name: '會員管理',
  },
  {
    scope: ['3101'],
    component: 'CNavItem',
    functionName: 'MemberCard',
    name: '3101 - 會員管理',
    to: '/memberCard/3101',
  },
  {
    scope: ['3102'],
    component: 'CNavItem',
    functionName: 'MemberCard',
    name: '3102 - 商店收據查詢',
    to: '/memberCard/3102',
  },
  {
    scope: ['3103'],
    component: 'CNavItem',
    functionName: 'MemberCard',
    name: '3103 - 心禮卡管理',
    to: '/memberCard/3103',
  },

  //音樂庫管理
  {
    scope: ['4101', '4102', '4104'],
    component: 'CNavTitle',
    moduleName: '音樂庫管理',
    name: '音樂庫管理',
  },
  {
    scope: ['4101'],
    component: 'CNavItem',
    functionName: 'MusicStorge',
    name: '4101 - 創作者管理',
    to: '/musicStorge/4101',
  },
  {
    scope: ['4102'],
    component: 'CNavItem',
    functionName: 'MusicStorge',
    name: '4102 - 歌曲管理',
    to: '/musicStorge/4102',
  },
  {
    scope: ['4104'],
    component: 'CNavItem',
    functionName: 'MusicStorge',
    name: '4104 - 歌單/專輯管理',
    to: '/musicStorge/4104',
  },

  //首頁管理
  {
    scope: ['5101', '5102', '5103', '5104'],
    component: 'CNavTitle',
    moduleName: '首頁管理',
    name: '首頁管理',
  },
  {
    scope: ['5101'],
    component: 'CNavItem',
    functionName: 'HomePage',
    name: '5101 - 輪播公告管理',
    to: '/homePage/5101',
  },
  {
    scope: ['5102'],
    component: 'CNavItem',
    functionName: 'HomePage',
    name: '5102 - STAR 精選管理',
    to: '/homePage/5102',
  },
  {
    scope: ['5103'],
    component: 'CNavItem',
    functionName: 'HomePage',
    name: '5103 - 自定區塊管理',
    to: '/homePage/5103',
  },
  {
    scope: ['5104'],
    component: 'CNavItem',
    functionName: 'HomePage',
    name: '5104 - 訊息通知管理',
    to: '/homePage/5104',
  },

  //MV管理
  {
    scope: ['6101'],
    component: 'CNavTitle',
    moduleName: 'MV 管理',
    name: 'MV 管理',
  },
  {
    scope: ['6101'],
    component: 'CNavItem',
    functionName: 'MV',
    name: '6101 - MV 區塊管理',
    to: '/mv/6101',
  },

  //權限管理
  {
    scope: ['1101'],
    component: 'CNavTitle',
    moduleName: '權限管理',
    name: '權限管理',
  },
  {
    scope: ['1101'],
    component: 'CNavItem',
    functionName: 'UserMgt',
    name: '1101 - 使用者帳號管理',
    to: '/userMgt/1101',
  },
]
